<template>
  <v-app>
    <v-app-bar
      app
      class="gradiente-nav"
      dark
      :clipped-left="$vuetify.breakpoint.mdAndUp"
    >
      <v-app-bar-nav-icon
        v-if="esta_logueado"
        @click.stop="drawer = !drawer"
        style="color: black"
      ></v-app-bar-nav-icon>
      <div
        :class="$vuetify.breakpoint.mdAndUp ? 'subtitle-1' : 'caption'"
        class="black--text"
      >
        {{ $t("appbar-t1") }}
      </div>
      <v-spacer></v-spacer>
      <div v-if="esta_en_mora">
        <v-alert dense type="error" class="my-auto caption">
          El estado actual de su licencia presenta <strong>MORA</strong>, favor
          contacte al administrador de sistema para evitar desconexión del
          sistema. <br />
          Enviar comprobante de pago al correo:
          <strong>cobros@devco.sv</strong> <br />
          <strong>
            Efectúa tu pago antes del 15 de junio 2026 y evita
            desconexiones.</strong
          >
        </v-alert>
      </div>
      <v-spacer></v-spacer>
      <v-menu bottom left v-if="$store.state.emp.id_empresa == 91">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon>fa-solid fa-language</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, i) in items_idiomas"
            :key="i"
            @click="cambiarIdioma2(item.locale)"
          >
            <v-list-item-title>{{ item.nombre }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        class="ml-5"
        v-if="esta_logueado"
        color="primary"
        @click="cerrarSesion()"
        >{{ $t("appbar-btn1") }}</v-btn
      >
    </v-app-bar>

    <v-navigation-drawer
      app
      v-model="drawer"
      :clipped="$vuetify.breakpoint.mdAndUp"
      v-if="esta_logueado"
    >
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6 text-center">
              {{
                $store.state.usuario == null ? "" : $store.state.usuario.nombre
              }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-center wrap-text">{{
              $store.state.emp ? $store.state.emp.nombre_empresa : ""
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <!-- INICIO-->
      <v-list dense>
        <v-list-item
          v-for="item in itemsInicio"
          :key="item.title"
          :to="item.href"
          active-class="primary--text"
          v-if="moduloVisible(item.href, 'inicio')"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <!-- ADMINISTRACION-->
      <v-list-group v-if="flag_admin">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title class="text-center body-2 font-weight-bold">{{
              $t("drawer-admin")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="item in itemsAdmin"
          :key="item.title"
          :to="item.href"
          dense
          style="background-color: white"
          v-if="moduloVisible(item.href, 'administrador')"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- CATALOGOS-->
      <v-list-group v-if="flag_catalogo">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title class="text-center body-2 font-weight-bold">{{
              $t("drawer-catalog")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="item in itemsCatalogos"
          :key="item.title"
          :to="item.href"
          dense
          v-if="moduloVisible(item.href, 'catalogos')"
          style="background-color: white"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- REPORTERIA-->
      <v-list-group v-if="flag_reporteria">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title class="text-center body-2 font-weight-bold">{{
              $t("drawer-reporting")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="item in itemsReporteria"
          :key="item.title"
          :to="item.href"
          dense
          v-if="moduloVisible(item.href, 'reporteria')"
          style="background-color: white"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- REPORTERIA CUENTAS POR COBRAR -->
      <v-list-group v-if="flag_reporteria_cxc">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title class="text-center body-2 font-weight-bold">{{
              $t("drawer-reporting-cxc")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="item in itemsCXC"
          :key="item.title"
          :to="item.href"
          dense
          v-if="moduloVisible(item.href, 'reporteria_cxc')"
          style="background-color: white"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- CUENTAS POR COBRAR -->
      <v-list-group v-if="flag_cxc">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title
              class="text-center body-2 font-weight-bold wrap-text"
              >{{ $t("drawer-accountsReceivable") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="item in itemsCuentasXCobrar"
          :key="item.title"
          :to="item.href"
          dense
          v-if="moduloVisible(item.href, 'cxc')"
          style="background-color: white"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider></v-divider>

      <!-- ITEMS SEPARADOS-->
      <v-list dense>
        <v-list-item
          v-for="item in itemsSeparados"
          :key="item.title"
          :to="item.href"
          active-class="primary--text"
          v-if="moduloVisible(item.href, 'separado')"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-footer app padless color="#4CC7C4">
      <v-card flat tile color="transparent">
        <v-card-text>
          <a
            href="https://www.facebook.com/profile.php?id=100066456685999"
            target="_blank"
            class="mx-4"
          >
            <v-icon color="#2121b8" size="25"
              >fa-brands fa-square-facebook</v-icon
            >
          </a>
          <a
            href="https://www.instagram.com/devco.system/"
            target="_blank"
            class="mx-4"
          >
            <v-icon color="#de632e" size="25"
              >fa-brands fa-square-instagram</v-icon
            >
          </a>
          <a href="https://devco.sv/" target="_blank" class="mx-4">
            <v-icon color="#6161ec" size="25">fa-solid fa-globe</v-icon>
          </a>
        </v-card-text>
      </v-card>
      <div class="subtitle-2">
        <v-icon size="20">fa-solid fa-phone</v-icon> (+503) 2254-3300
      </div>
      <v-spacer></v-spacer>
      <v-img
        class="mx-4"
        :src="require('@/assets/logo_devco.png')"
        max-width="35"
        max-height="35"
      ></v-img>
    </v-footer>

    <v-dialog v-model="dialog_emp" width="700" persistent scrollable>
      <v-card>
        <v-toolbar color="light-blue" dark>
          <v-toolbar-title>{{ $t("welcome-dialog-t1") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_emp = !dialog_emp">
            <v-icon size="30">fa-regular fa-circle-xmark</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="headers"
            :items="items_emp"
            :items-per-page="-1"
            :search="search"
            dense
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                outlined
                dense
                hide-details
                :label="$t('search')"
                class="ma-2"
              ></v-text-field>
            </template>
            <template v-slot:[`item.action_select`]="{ item }">
              <v-icon @click="selecEmp(item)">
                fa-regular fa-hand-pointer
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
const signalR = require("@microsoft/signalr");

export default {
  data: () => ({
    drawer: true,
    items_permisos: [],
    estaLogueado: null,
    idioma: "es",
    items_idiomas: [
      { locale: "es", nombre: "Español" },
      { locale: "en", nombre: "Ingles" },
    ],
    esta_en_mora: false,
    connection: "",
    flag_admin: true,
    flag_admin_primera_vez: 1,
    flag_catalogo: true,
    flag_catalogo_primera_vez: 1,
    flag_reporteria: true,
    flag_reporteria_primera_vez: 1,
    flag_reporteria_cxc: true,
    flag_reporteria_primera_vez_cxc: 1,
    flag_cxc: true,
    flag_cxc_primera_vez: 1,
    flag_separado: true,
    flag_separado_primera_vez: 1,
    dialog_emp: false,
    items_emp: [],
    search: "",
  }),
  watch: {
    $route(to, from) {
      this.ejecutarAccionGlobal(to, from);
    },
  },
  computed: {
    esta_logueado() {
      var status_empresa = this.verificarEstatusEmpresa();
      if (
        this.$store.state.usuario == null &&
        (status_empresa == null || status_empresa == undefined)
      ) {
        localStorage.removeItem("cod_emp");
        return false;
      } else {
        axios
          .get("api/Usuarios/Listar/" + this.$store.state.usuario.idUsuario)
          .then((response) => {
            //console.log(response.data);
            if (!response.data[0].activo) {
              localStorage.removeItem("cod_emp");
              this.$store.dispatch("salir");
              return false;
            }
          });

        this.listaEmpresa();
        this.listarModulos();
        this.esVisibleModulo();
        return true;
      }
    },
    itemsInicio() {
      return [
        {
          title: this.$t("drawer-home"),
          icon: "fa-solid fa-house",
          href: "/",
          show: true,
        },
      ];
    },
    itemsAdmin() {
      return [
        {
          title: this.$t("drawer-admin-companies"),
          icon: "fa-solid fa-handshake",
          href: "empresas",
          show: true,
        },
        {
          title: this.$t("drawer-admin-users"),
          icon: "fa-solid fa-circle-user",
          href: "usuarios",
          show: true,
        },
        {
          title: this.$t("drawer-admin-roles"),
          icon: "fa-solid fa-user-gear",
          href: "roles",
          show: true,
        },
        {
          title: this.$t("drawer-admin-permision"),
          icon: "fa-solid fa-key",
          href: "permisos_modulos",
          show: true,
        },
      ];
    },
    itemsCatalogos() {
      return [
        {
          title: this.$t("drawer-catalog-customers"),
          icon: "fa-solid fa-users",
          href: "clientes",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-services"),
          icon: "fa-solid fa-rectangle-list",
          href: "servicios",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-product"),
          icon: "fa-solid fa-cube",
          href: "productos",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-consignees"),
          icon: "fa-solid fa-cube",
          href: "consignatarios",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-branches"),
          icon: "fa-solid fa-people-group",
          href: "sucursales",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-pointsOfsale"),
          icon: "fa-solid fa-people-group",
          href: "puntos_venta",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-vendors"),
          icon: "fa-solid fa-user-tag",
          href: "vendedores",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-suppliers"),
          icon: "fa-solid fa-user-tag",
          href: "proveedores",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-config"),
          icon: "fa-solid fa-screwdriver-wrench",
          href: "configuracion",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-confibuttons"),
          icon: "fa-solid fa-screwdriver-wrench",
          href: "permiso_botones",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-confiSmtp"),
          icon: "fa-solid fa-screwdriver-wrench",
          href: "configuracion_smtp",
          show: true,
        },
        {
          title: this.$t("drawer-catalog-confiClosing"),
          icon: "fa-solid fa-screwdriver-wrench",
          href: "configuracion_corte",
          show: true,
        },
        {
          title: "Bitacora correo FE",
          icon: "fa-solid fa-screwdriver-wrench",
          href: "bitacora_correo_fe",
          show: true,
        },
      ];
    },
    itemsReporteria() {
      return [
        {
          title: this.$t("drawer-reporting-customers"),
          icon: "fa-solid fa-receipt",
          href: "reporte_clientes",
          show: true,
        },
        {
          title: this.$t("drawer-reporting-suppliers"),
          icon: "fa-solid fa-receipt",
          href: "reporte_proveedores",
          show: true,
        },
        {
          title: this.$t("drawer-reporting-reportSale&purchase"),
          icon: "fa-solid fa-receipt",
          href: "reporte_compras_ventas",
          show: true,
        },
      ];
    },
    itemsCXC() {
      return [
        {
          title: this.$t("drawer-reporting-reportSale&purchasee"),
          icon: "fa-solid fa-receipt",
          href: "reporte_cxc",
          show: true,
        },
      ];
    },
    itemsCuentasXCobrar() {
      return [
        {
          title: this.$t("drawer-accountsReceivable-dailyIncome"),
          icon: "fa-solid fa-receipt",
          href: "ingresos_diarios",
        },
      ];
    },
    itemsSeparados() {
      return [
        {
          title: this.$t("drawer-invoicing"),
          icon: "fa-solid fa-file-invoice-dollar",
          href: "facturacion",
        },
        {
          title: this.$t("drawer-shop"),
          icon: "fa-solid fa-file-invoice-dollar",
          href: "compras",
        },
        {
          title: this.$t("drawer-vatBook"),
          icon: "fa-solid fa-book",
          href: "librosiva",
        },
        {
          title: this.$t("drawer-vatAnnexes"),
          icon: "fa-solid fa-book",
          href: "anexosiva",
        },
        {
          title: this.$t("drawer-salesSummary"),
          icon: "fa-solid fa-file-invoice-dollar",
          href: "resumen_ventas",
        },
        {
          title: this.$t("drawer-exportInvoices"),
          icon: "fa-solid fa-file-export",
          href: "exportacion_facturas",
        },
        {
          title: this.$t("drawer-exportInveoicesCsv"),
          icon: "fa-solid fa-file-export",
          href: "exportacion_fac_csv",
        },
        {
          title: this.$t("drawer-exportShopCsv"),
          icon: "fa-solid fa-file-export",
          href: "expor_compras",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("welcome-dialog-table-header-t1"),
          value: "nombre_empresa",
        },
        {
          text: this.$t("welcome-dialog-table-header-t2"),
          value: "action_select",
          align: "center",
        },
      ];
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);

    this.connection.on("Receive", (user, data) => {
      const insertdata = { name: user, message: data };

      //console.log("escuchando...", insertdata);
      this.obtenerMora();
    });
  },
  created() {
    this.$store.dispatch("autoLogin");

    this.connection = new signalR.HubConnectionBuilder()
      .withAutomaticReconnect()
      .withUrl(process.env.VUE_APP_URL_API + "/hubResponse", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();

    this.connection
      .start()
      .then(() => {
        console.log("Conexión establecida");
      })
      .catch((error) => {
        //console.log(error);
      });
  },
  methods: {
    handleKeydown(e) {
      if (this.$store.state.usuario.rol == "IT") {
        if ((e.ctrlKey && e.key === "a") || (e.ctrlKey && e.key === "A")) {
          e.preventDefault();
          this.listarEmpresas();
        }
      }
    },
    listarEmpresas() {
      axios
        .get(
          "api/UsuariosXEmpresas/ListarSinLogo/" +
            this.$store.state.usuario.idUsuario
        )
        .then((response) => {
          //console.log(response.data);
          if (response.data.length == 1 && !localStorage.getItem("cod_emp")) {
            this.selecEmp(response.data[0]);
            return;
          }
          this.dialog_emp = true;
          this.items_emp = response.data;
        });
    },
    selecEmp(item) {
      this.dialog_emp = false;
      axios
        .put("api/Usuarios/ActualizarEmpSeleccionada", {
          id_usuario: this.$store.state.usuario.idUsuario,
          emp_seleccionada: item.id_empresa,
        })
        .then(() => {
          localStorage.setItem("cod_emp", item.id_empresa);
          this.$store.dispatch("guardarEmpresa", item);
        });
    },
    ejecutarAccionGlobal(to, from) {
      //console.log('Acción global ejecutada')
      axios
        .get("api/Usuarios/Listar/" + this.$store.state.usuario.idUsuario)
        .then((response) => {
          //console.log(response.data);
          if (!response.data[0].activo) {
            localStorage.removeItem("cod_emp");
            this.$store.dispatch("salir");
          } else {
            this.obtenerMora();
          }
        });
    },
    obtenerMora() {
      axios
        .get(
          "api/DetallesEmpresas/ObtenerMora/" + this.$store.state.emp.id_empresa
        )
        .then((response) => {
          //console.log(response.data);
          this.esta_en_mora = response.data;
        });
    },
    verificarEstatusEmpresa() {
      if (
        localStorage.getItem("cod_emp") != undefined &&
        localStorage.getItem("cod_emp") != null
      ) {
        return axios.get(
          "api/DetallesEmpresas/VerificarEstado/" +
            localStorage.getItem("cod_emp")
        ).data;
      } else {
        return null;
      }
    },
    listaEmpresa() {
      let cod_emp = localStorage.getItem("cod_emp");
      if (cod_emp) {
        axios
          .get(
            "api/UsuariosXEmpresas/ListarXcodEmp/" +
              cod_emp +
              "/" +
              this.$store.state.usuario.idUsuario
          )
          .then((response) => {
            //console.log(response.data);
            this.$store.dispatch("guardarEmpresa", response.data[0]);
          })
          .catch(() => {
            console.log("error");
          });
      }
    },
    listarModulos() {
      axios
        .get(
          "api/PermisosPantallas/Listar/" + this.$store.state.usuario.idUsuario
        )
        .then((response) => {
          //console.log(response.data);
          this.items_permisos = response.data;
        });
    },
    esVisibleModulo() {
      var path = window.location.pathname;

      axios
        .get(
          "api/PermisosPantallas/EsVisibleModulo/" +
            this.$store.state.usuario.idUsuario +
            path
        )
        .then((response) => {
          if (response.data.length == 0) {
            this.$router.push({ name: "bienvenido" }).catch(() => {});
          }
        });
    },
    moduloVisible(item, grupo) {
      //console.log(item, grupo);
      if (grupo == "administrador") {
        var item_ = this.items_permisos.find(
          (object) => object.nombre_pantalla_identificador == item
        );

        if (item_) {
          if (item_.visible == false) {
            if (
              this.flag_admin === false ||
              this.flag_admin_primera_vez === 1
            ) {
              this.flag_admin = false;
              this.flag_admin_primera_vez = 0;
            }
          } else {
            this.flag_admin = true;
            this.flag_admin_primera_vez = 0;
            return true;
          }
        }
      } else if (grupo === "catalogos") {
        var item_ = this.items_permisos.find(
          (object) => object.nombre_pantalla_identificador == item
        );

        if (item_) {
          if (item_.visible == false) {
            if (
              this.flag_catalogo === false ||
              this.flag_catalogo_primera_vez === 1
            ) {
              this.flag_catalogo = false;
              this.flag_catalogo_primera_vez = 0;
            }
          } else {
            this.flag_catalogo = true;
            this.flag_catalogo_primera_vez = 0;
            return true;
          }
        }
      } else if (grupo === "reporteria") {
        var item_ = this.items_permisos.find(
          (object) => object.nombre_pantalla_identificador == item
        );

        if (item_) {
          if (item_.visible == false) {
            if (
              this.flag_reporteria === false ||
              this.flag_reporteria_primera_vez === 1
            ) {
              this.flag_reporteria = false;
              this.flag_reporteria_primera_vez = 0;
            }
          } else {
            this.flag_reporteria = true;
            this.flag_reporteria_primera_vez = 0;
            return true;
          }
        }
      } else if (grupo === "reporteria_cxc") {
        var item_ = this.items_permisos.find(
          (object) => object.nombre_pantalla_identificador == item
        );
        if (item_) {
          if (item_.visible == false) {
            if (
              this.flag_reporteria_cxc === false ||
              this.flag_reporteria_primera_vez_cxc === 1
            ) {
              this.flag_reporteria_cxc = false;
              this.flag_reporteria_primera_vez_cxc = 0;
            }
          } else {
            this.flag_reporteria_cxc = true;
            this.flag_reporteria_primera_vez_cxc = 0;
            return true;
          }
        }
      } else if (grupo === "cxc") {
        var item_ = this.items_permisos.find(
          (object) => object.nombre_pantalla_identificador == item
        );

        if (item_) {
          if (item_.visible == false) {
            if (this.flag_cxc === false || this.flag_cxc_primera_vez === 1) {
              this.flag_cxc = false;
              this.flag_cxc_primera_vez = 0;
            }
          } else {
            this.flag_cxc = true;
            this.flag_cxc_primera_vez = 0;
            return true;
          }
        }
      } else if (grupo === "separado") {
        var item_ = this.items_permisos.find(
          (object) => object.nombre_pantalla_identificador == item
        );

        if (item_) {
          if (item_.visible == false) {
            if (
              this.flag_separado === false ||
              this.flag_separado_primera_vez === 1
            ) {
              this.flag_separado = false;
              this.flag_separado_primera_vez = 0;
            }
          } else {
            this.flag_separado = true;
            this.flag_separado_primera_vez = 0;
            return true;
          }
        }
      } else {
        var item_ = this.items_permisos.find(
          (object) => object.nombre_pantalla_identificador == item
        );

        if (item_) {
          if (item_.visible) {
            return true;
          }
        }
      }

      /*
      var item_ = this.items_permisos.find(
          (object) => object.nombre_pantalla_identificador == item
        );

        if (item_) {
          if (item_.visible) {
            return true;
          }
        }
      */
    },
    cerrarSesion() {
      localStorage.removeItem("cod_emp");
      this.$store.dispatch("salir");
    },
    cambiarIdioma2(idioma) {
      //console.log(idioma);
      this.$i18n.locale = idioma;
      localStorage.setItem("locale-fe", idioma);
    },
  },
};
</script>

<style>
a {
  text-decoration: none;
}

.fa-square-instagram {
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.wrap-text {
  white-space: normal;
}

.gradiente-nav {
  background-image: radial-gradient(
    circle at 0% 0%,
    #82e0d6 0,
    #6ad4cd 25%,
    #4cc7c3 50%,
    #1fbaba 75%,
    #00aeb2 100%
  );
}
</style>